module.exports = {"ru":{"title":"Скачать XLS"},"en":{"title":"Download XLS"}}